module.exports = __webpack_public_path__ + "media/images/mobile/city_img/k-66781291ff3a71accce5f779572567a0.jpg";